import React, { MouseEvent } from "react"

import clsName from './index.module.scss'
import { unlockForm } from "../../../api/data"
import { Modal } from "antd-mobile-v5"

interface FormUnlockProps {
  editModel: number
  state: string
  formId: number
  children: React.ReactNode
  onReload: ()=> void
}

const FormUnlock: React.FC<FormUnlockProps> = ({ formId, state, editModel, children, onReload })=> {
  const handleClick = (e: MouseEvent)=> {
    e.stopPropagation()
    if (editModel === 1 && state === 'Complete') {
      Modal.confirm({
        content: '确定解锁此表单？',
        onConfirm: async ()=> {
          const { code, message } = await unlockForm(formId)
          if (code === 0) {
            onReload()
          } else {
            Modal.alert({
              content: message
            })
          }
        }
      })
    }
  }

  if (!children) {
    return null
  }
  
  return (
    <button onClick={handleClick} type="button" className={clsName.wrapper}>
      {children}
    </button>
  )
}

export default FormUnlock